import axios from "axios";

export interface ClientErrorLog {
    referenceGuid: string; // Guid in C# maps to string in TS
    url: string;
    clientError: string;
    clientStacktrace: string;
}

export const logErrorGrayLog = (clientErrorLog: ClientErrorLog) => {
    // Send to clientLogger
    axios.post("/api/v1/ClientLogger", clientErrorLog)
        .then(() => {
            console.log("Sent to ClientLogger", clientErrorLog);
        })
        .catch((error) => {
            console.error('Error sending to ClientLogger', error);
        });        
}